export default __webpack_public_path__ + "static/media/20201206-IMG_1315.6051a83e.webp";